



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllRejectedPlansWithCreatorAndRejector
// GETALLREJECTEDPLANSWITHCREATORANDREJECTOR


const GETALLREJECTEDPLANSWITHCREATORANDREJECTOR= createAsyncThunk(
  "getAllRejectedPlansWithCreatorAndRejector/getAllRejectedPlansWithCreatorAndRejector",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllRejectedPlansWithCreatorAndRejectorSlice = createSlice({
  name: "getAllRejectedPlansWithCreatorAndRejectorSlice",
  initialState: {
    getAllRejectedPlansWithCreatorAndRejector: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllRejectedPlansWithCreatorAndRejector: (state) => {
        state.getAllRejectedPlansWithCreatorAndRejector.loading = false
        state.getAllRejectedPlansWithCreatorAndRejector.error = false
        state.getAllRejectedPlansWithCreatorAndRejector.data = []
        state.getAllRejectedPlansWithCreatorAndRejector.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREJECTEDPLANSWITHCREATORANDREJECTOR.fulfilled, (state, action) => {
      state.getAllRejectedPlansWithCreatorAndRejector = {
        ...state.getAllRejectedPlansWithCreatorAndRejector,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREJECTEDPLANSWITHCREATORANDREJECTOR.pending, (state, action) => {
      state.getAllRejectedPlansWithCreatorAndRejector = {
        ...state.getAllRejectedPlansWithCreatorAndRejector,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREJECTEDPLANSWITHCREATORANDREJECTOR.rejected, (state, action) => {
      state.getAllRejectedPlansWithCreatorAndRejector = {
        ...state.getAllRejectedPlansWithCreatorAndRejector,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllRejectedPlansWithCreatorAndRejectorAction = {
    GETALLREJECTEDPLANSWITHCREATORANDREJECTOR,
};

export { getAllRejectedPlansWithCreatorAndRejectorAction };
export default getAllRejectedPlansWithCreatorAndRejectorSlice.reducer;
export const {setInitialStateOfgetAllRejectedPlansWithCreatorAndRejector} = getAllRejectedPlansWithCreatorAndRejectorSlice.actions
